/** Fuegt Klassennamen zusammen und wirft falsche Werte weg. */
export function cn(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(' ');
}
